/**
 * Callable Cloud Functions for org admins/managers (staff username accounts, etc.)
 */

export async function setOrganizationMemberPassword(
  organizationId: string,
  targetUserId: string,
  newPassword: string
): Promise<{ success: boolean; error?: string }> {
  try {
    const { httpsCallable, getFunctions } = await import('firebase/functions');
    const functions = getFunctions();
    const fn = httpsCallable<
      { organizationId: string; targetUserId: string; newPassword: string },
      { success: boolean }
    >(functions, 'setOrganizationMemberPassword');
    await fn({ organizationId, targetUserId, newPassword });
    return { success: true };
  } catch (e: any) {
    const raw = typeof e?.message === 'string' ? e.message : String(e?.code || 'Failed');
    const msg = raw.includes(':') ? raw.replace(/^[^:]+:\s*/, '') : raw;
    return { success: false, error: msg };
  }
}
